export { default } from './InsightsIframe';
